export default {"src":"/_next/static/media/trustpilot-vector-logo.8e7e0e17.svg","height":26,"width":106,"blurWidth":0,"blurHeight":0};